<template>
  <div class="new-message" :id="`new-node-${nodeType}`" @click="handleCreateNode">
    <component :is="currentNode.icon" class="new-message__icon" />
    <p class="new-message__description">Agregar {{ currentNode.name }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { NodeData } from "@/app/chatbots/utils/enums";

const props = defineProps<{
  nodeType: number;
}>();

const emit = defineEmits<{
  click: [nodeType: number];
}>();

const handleCreateNode = () => {
  emit("click", props.nodeType);
};

const currentNode = computed(() => {
  return NodeData[props.nodeType as keyof typeof NodeData];
});
</script>

<style scoped lang="sass">
.new-message
  height: 126px
  background: #FFF
  border-radius: 4px
  border: 1px dashed $primary
  padding: 30px
  cursor: pointer
  display: flex
  justify-content: center
  align-content: center
  flex-direction: column

  &__icon
    display: block
    color: $primary
    font-size: 24px
    margin-bottom: 4px

  &__description
    font-size: 14px
    text-align: center
    color: $primary
    margin: 0
    width: 120px
</style>
